module.exports = ngModule => {
  ngModule.constant('formlyVersion', VERSION);
};



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./providers/formlyVersion.js
 **/